import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
export function CallToAction() {
  const {
    t
  } = useLanguage();
  return <section className="py-32 relative overflow-hidden flex items-center justify-center bg-[#134E4A]" data-id="element-47">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#D4A843]/10 rounded-full blur-[100px] pointer-events-none" data-id="element-48"></div>

      <div className="relative z-10 text-center px-6 max-w-3xl mx-auto" data-id="element-49">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl lg:text-6xl font-serif text-white mb-8 leading-tight" data-id="element-50">
          {t('cta.title.part1')}{' '}
          <span className="text-[#D4A843] italic" data-id="element-51">{t('cta.title.part2')}</span>{' '}
          <br data-id="element-52" /> {t('cta.title.part3')}
        </motion.h2>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-teal-50/80 text-lg mb-12 font-light" data-id="element-53">
          {t('cta.desc')}
        </motion.p>

        <motion.button initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="bg-[#D4A843] text-white px-12 py-5 text-lg font-semibold tracking-widest uppercase hover:bg-white hover:text-[#0D9488] transition-colors duration-300 shadow-[0_0_30px_rgba(212,168,67,0.3)]" data-id="element-54">
          {t('cta.button')}
        </motion.button>
      </div>
    </section>;
}